module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChange]
    }
  }, _vm._l((_vm.availableLocales), function(value) {
    return _c('option', {
      domProps: {
        "value": value.id,
        "selected": value.id === _vm.current
      }
    }, [_vm._v("\n            " + _vm._s(value.name) + "\n        ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-204ad460!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/I18n.vue
// module id = 1245
// module chunks = 2